import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Modal from '../Modal'
import PaymentForm from '../../Settings/Billing/PaymentForm'

import {
  getAnnualToggle,
  getUpdateCardFlag,
  getUpdatePaymentSettingsFlag,
  setUpdateCardFlag,
  setUpdatePaymentSettingsFlag,
  setPlanSelectedFlag,
  getSelectedPlanValue,
  getSubscription,
  getPaymentRouteType,
  setSwitchToYearlyFlag,
} from '../../../ducks/trialWarning'
import { getOrganization } from '../../../ducks/organizations'
import { IconButton } from '../Icon'
import history from '../../../history'

class PayModal extends Component {
  closeModal = () => {
    const {
      match,
      setUpdateCardFlag,
      setUpdatePaymentSettingsFlag,
      setSwitchToYearlyFlag,
      onClickBackChangePlan,
    } = this.props

    setUpdateCardFlag(false)
    setUpdatePaymentSettingsFlag(false)
    setSwitchToYearlyFlag(false)
    onClickBackChangePlan()

    history.push(`/apps/${match.params.appId}/screens`)
  }

  renderContent() {
    const {
      submitting,
      error,
      submitText,
      annual,
      updatePaymentSettings,
      onSubmit,
      onClickBackChangePlan,
      selectedPlanValue,
      updateCardFlag,
      setUpdateCardFlag,
      setPlanSelectedFlag,
      subscription = {},
      setSwitchToYearlyFlag,
      couponCode,
      organizationId,
    } = this.props

    let title
    let subheader
    const { planType } = subscription

    const onClickBack = () => {
      setPlanSelectedFlag(updateCardFlag)
      setSwitchToYearlyFlag(updateCardFlag)
      setUpdateCardFlag(false)
    }

    const subscriptionHeading = updatePaymentSettings
      ? planType
      : selectedPlanValue

    if (annual) {
      if (subscriptionHeading === 'business') {
        title = "You're one step away from Business Plan Yearly!"
        subheader = 'Business Plan Yearly'
      } else {
        title = "You're one step away from Pro Plan Yearly!"
        subheader = 'Pro Plan Yearly'
      }
    } else {
      if (subscriptionHeading === 'business') {
        title = "You're one step away from the Business Plan!"
        subheader = 'Monthly Business Plan'
      } else {
        title = "You're one step away from the Pro Plan!"
        subheader = 'Monthly Pro Plan'
      }
    }

    return (
      <>
        {updatePaymentSettings ? (
          <Modal.Header title="Update Payment Settings" />
        ) : (
          <Modal.Header title={title} />
        )}
        <Modal.Content
          style={{
            maxHeight: 'calc(100vh - 210px)',
            overflowY: 'auto',
          }}
        >
          <Modal.Container>
            {!updatePaymentSettings && (
              <div className="payment-form-subheader">{subheader}</div>
            )}
            {error && !submitting && (
              <div className="pay-settings-alert">{error}</div>
            )}
            <PaymentForm
              couponCode={couponCode}
              organizationId={organizationId}
            />
          </Modal.Container>
        </Modal.Content>
        <Modal.Actions>
          {updatePaymentSettings ? (
            <Modal.Button type="button" text onClick={onClickBackChangePlan}>
              Back
            </Modal.Button>
          ) : (
            <Modal.Button type="button" text onClick={onClickBack}>
              Back
            </Modal.Button>
          )}
          {updatePaymentSettings ? (
            <Modal.Button
              large
              type="submit"
              onClick={onSubmit}
              loading={submitting}
            >
              Update
            </Modal.Button>
          ) : (
            <Modal.Button
              large
              type="submit"
              onClick={onSubmit}
              loading={submitting}
            >
              {submitText}
            </Modal.Button>
          )}
        </Modal.Actions>
      </>
    )
  }

  render() {
    const { paymentRouteType, onCancel } = this.props

    if (paymentRouteType === 'billing') {
      return (
        <Modal size="lg" onClose={onCancel}>
          <div className="settings-page-close-button">
            <IconButton type="close-big" onClick={this.closeModal} />
          </div>
          {this.renderContent()}
        </Modal>
      )
    } else {
      return this.renderContent()
    }
  }
}

PayModal.propTypes = {
  submitText: PropTypes.string,
}

PayModal.defaultProps = {
  submitText: 'Upgrade',
}

const mapStateToProps = (state, { organizationId }) => {
  return {
    updateCardFlag: getUpdateCardFlag(state),
    updatePaymentSettings: getUpdatePaymentSettingsFlag(state),
    annual: getAnnualToggle(state),
    selectedPlanValue: getSelectedPlanValue(state),
    subscription: getSubscription(
      state,
      getOrganization(state, organizationId)
    ),
    paymentRouteType: getPaymentRouteType(state),
  }
}

const connected = connect(mapStateToProps, {
  setUpdateCardFlag,
  setUpdatePaymentSettingsFlag,
  setPlanSelectedFlag,
  setSwitchToYearlyFlag,
})(PayModal)

export default withRouter(connected)
